import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { Monitor, MonitorWithMetrics } from '../types';
import { addMetricsToResource } from './techMetrics';

export const useMonitorWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<Monitor[], Error, MonitorWithMetrics[]>({
    queryKey: ['monitor', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () => apiFetch<Monitor[]>(API_ENDPOINTS.COMMON.technology.monitor),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) => addMetricsToResource(data, conditionedSpaceArea),
  });
};
